import outline from "../../assets/icons/doctor_video.svg";
import doctorVideo from "../../assets/portfolio.mp4";
import React, { useRef, useState } from "react";
import { Play, Pause, Maximize, RotateCcw, RotateCw } from "lucide-react";
import poster from "../../assets/images/video_poster.png";

const AboutVideo = () => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const [duration, setDuration] = useState(0);
  // Play / Pause
  const togglePlay = () => {
    if (!videoRef.current) return;
    if (isPlaying) {
      videoRef.current.pause();
    } else {
      videoRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };
  // pdate Progress
  const handleTimeUpdate = () => {
    const current = videoRef.current.currentTime;
    const total = videoRef.current.duration;
    setProgress((current / total) * 100);
  };
  // Duration
  const handleLoadedMetadata = () => {
    setDuration(videoRef.current.duration);
  };
  // Seek
  const handleSeek = (e) => {
    const value = e.target.value;
    videoRef.current.currentTime = (value / 100) * videoRef.current.duration;
    setProgress(value);
  };
  // Forward / Backward
  const skip = (seconds) => {
    videoRef.current.currentTime += seconds;
  };
  // Fullscreen
  const handleFullscreen = () => {
    if (videoRef.current.requestFullscreen) {
      videoRef.current.requestFullscreen();
    }
  };
  // Format Time
  const formatTime = (time) => {
    if (!time) return "0:00";
    const mins = Math.floor(time / 60);
    const secs = Math.floor(time % 60);
    return `${mins}:${secs < 10 ? "0" : ""}${secs}`;
  };

  return (
    <div className="xl:py-28 lg:py-20 md:py-14 py-10 relative overflow-hidden ">
      {/* Background Outline */}
      <div className="top-0 left-0 absolute md:w-1/3 w-full  ">
        <img
          src={outline}
          alt="outline" 
          className="pointer-events-none w-full h-auto"
        />
      </div>
      <div data-aos="fade-up" className="xl:w-[1280px] 2xl:px-0 xl:px-10 px-0 w-11/12 mx-auto flex justify-center items-center flex-col relative z-10">
        <span className="text-xl font-medium text-[#1d9e75] uppercase border-b border-[#B87333]  px-2 py-1.5">
          Doctor’s Message
        </span>
        <h2 className="lg:text-4xl md:text-3xl text-xl text-center font-bold mt-2 text-matcha leading-tight">
          A Message of Care, Hope & Healing
        </h2>
        {/* Video Section */}
        <div className="relative overflow-hidden rounded-xl group w-full mt-16 border border-vanilla">
          {/* VIDEO */}
          <video
            ref={videoRef}
            src={doctorVideo}
            poster={poster} preload="none"
            className="w-full h-full object-cover"
            onTimeUpdate={handleTimeUpdate}
            onLoadedMetadata={handleLoadedMetadata}
            
          />

          {/* CENTER PLAY BUTTON */}
          {!isPlaying && (
            <div className="absolute inset-0 flex items-center justify-center">
              <button
                onClick={togglePlay}
                className="relative flex items-center justify-center w-20 h-20 rounded-full bg-matcha backdrop-blur-md border border-white/30"
              >
                {/* WAVE */}
                <span className="absolute w-full h-full rounded-full border border-matcha animate-ping"></span>

                <Play
                  size={32}
                  className="text-white relative z-10 ml-1"
                  fill="#fff"
                />
              </button>
            </div>
          )}

          {/* CONTROLS */}
          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 w-[95%]">
            <div className="backdrop-blur-xl bg-matcha border border-white/10 rounded-2xl sm:px-4 px-2 py-3 flex items-center gap-2 sm:gap-4">
              {/* PLAY */}
              <button onClick={togglePlay}>
                {isPlaying ? (
                  <Pause className="text-white" size={20} />
                ) : (
                  <Play className="text-white" size={20} fill="white" />
                )}
              </button>

              {/* BACKWARD */}
              <button onClick={() => skip(-10)}>
                <RotateCcw className="text-white" size={18} />
              </button>

              {/* FORWARD */}
              <button onClick={() => skip(10)}>
                <RotateCw className="text-white" size={18} />
              </button>

              {/* TIME */}
              <span className="text-white text-sm w-[45px]">
                {formatTime(videoRef.current?.currentTime)}
              </span>

              {/* SEEK BAR */}
              <input
                type="range"
                min="0"
                max="100"
                value={progress}
                onChange={handleSeek}
                className="w-full h-1 appearance-none bg-white/30 rounded-full cursor-pointer"
              />

              {/* DURATION */}
              <span className="text-white text-sm w-[45px]">
                {formatTime(duration)}
              </span>

              {/* FULLSCREEN */}
              <button onClick={handleFullscreen}>
                <Maximize className="text-white" size={18} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutVideo;
